import React from 'react';
import Search from 'layouts/header/search/search';
import Container from 'atomic/container';
import Navigation from 'layouts/header/navigation/navigation';
import useToggle from 'hooks/use-toggle';

import './header.desktop.scss';

export const HeaderDesktop: React.FC = () => {
    const [isOpenMenu, menuState] = useToggle();

    return (
        <>
            <header className="header" data-section="header">
                <Container>
                    <div className="header__partial">
                        <Navigation onToggle={menuState.toggle} isOpen={isOpenMenu} />
                        <Search />
                    </div>
                </Container>
            </header>
        </>
    );
};

export default HeaderDesktop;
